/* sts-track.js - see docs/new-theme-v4/asset-notes/sts-track.md
   (header moved 2026-09-21: the size gate bills source gzip, the CDN strips it) */
(function (w, d) {
  'use strict';

  var cfg = w.STS_TRACK || {};
  var ads = cfg.ads || {};
  var DEBUG = !!cfg.debug;

  /* ───────────────────────────── the restricted field lists ───────────────── */

  /* Never leaves the site to an ad destination. No setting, no argument, no
     override. Photo and loyalty are here because slice brief item 5 is explicit:
     no photo data and no loyalty data may reach any ad pixel, ever. Sensitivity
     and concerns are here rather than under a setting for the same reason — the
     only sensitivity that may reach Meta is the one the quiz already sends from
     its own file, which this module never sees. */
  var BLOCKED = /(photo|image_url|selfie|check_?in_image|concern|eye_area|aesthetic|condition|diagnos|sensitiv|allerg|pregnan|medicat|prescription|milestone|reward|points|balance|loyalt|skin_?cash|credit|tier|email|phone|zip|postal|birth|dob|first_?name|last_?name)/i;

  /* Deleted unless cfg.ads.skinType is true — which requires written legal
     approval per 09-Q11 and a theme-settings commit on a connected branch, so
     flipping it is auditable in git. Default false. */
  var GATED_TYPE = /^(skin_?type|type_?code|type_?number|letters?|letter|bars?|barred|fit)$/i;

  /* Reserved for the concerns half of 09-Q11. Everything it would match is
     already in BLOCKED today, so the setting currently opens nothing; it exists
     so that the day the answer arrives the two halves can be opened
     independently rather than by widening BLOCKED. */
  var GATED_CONCERN = /^(concerns?|concern_list|aesthetic_concerns|other_concerns)$/i;

  /* ───────────────────────────── the event registry (§6.9) ────────────────── */

  /* Spec §6.9's 35 names plus the three failure-and-decline arms named below, so
     that a typo in a template shows up in the console in debug mode instead of
     quietly creating a second, differently-spelled GA4 event that nobody
     notices for a quarter. Unknown names still fire — a warning, never a block,
     because losing an event is worse than logging one.

     `sts_reward_claim_failed` is the failure arm of §6.9 #28: assets/sts-loyalty
     .js sends `sts_reward_claimed` from the claim's success path and this from
     its catch, so the two are one event pair and the table's row 28 is only half
     the claim flow. It stays out of KLAVIYO_EVENTS and out of the
     `analytics_ad_allowed_events` default for the same reason row 27
     (`sts_rewards_ledger_open`) does — a failed claim is a diagnostic, not an
     audience.

     `sts_library_topics_skip` is the same shape: assets/sts-library.js sends
     row 32's `sts_library_topics_saved` from the picker's Save and this from its
     Skip, so the two are one decision seen twice and row 32 is only half of it.
     Skipping is the reader declining to hand over an interest list, so it stays
     out of KLAVIYO_EVENTS and out of the ad allow-list.

     `sts_routine_steps_empty` is the third of the same shape: assets/sts-steps
     .js sends row 30's `sts_routine_steps_view` when the sheet has steps and
     this when it has none, with `reason` separating a typed visitor whose
     routine did not arrive from an untyped one who never had a routine to
     print. Row 30 alone counts only the happy half, which is the half that
     needs no attention. Diagnostic, so no Klaviyo and no ad allow-list. */
  var EVENTS = [
    'sts_state_resolved', 'sts_quiz_cta_click', 'sts_signin_banner_click',
    'sts_auth_submit', 'sts_resume_quiz_click', 'sts_retake_quiz_click',
    'sts_type_menu_select', 'sts_locked_filter_tap', 'sts_approved_only_toggle',
    'sts_filter_apply', 'sts_grid_density_change', 'sts_fit_view',
    'sts_buy_anyway_prompt', 'sts_add_to_routine', 'sts_sticky_atc_click',
    'sts_subscribe_select', 'sts_fbt_add', 'sts_regimen_add', 'sts_regimen_edit',
    'sts_preference_saved', 'sts_regimen_regenerated', 'sts_budget_rebuild',
    'sts_preferences_reset', 'sts_upsell_add', 'sts_refill_prompt',
    'sts_buy_again', 'sts_rewards_ledger_open', 'sts_reward_claimed',
    'sts_reward_claim_failed',
    'sts_photo_checkin', 'sts_routine_steps_view', 'sts_print_routine',
    'sts_routine_steps_empty',
    'sts_library_topics_saved', 'sts_library_topics_skip',
    'sts_library_search', 'sts_article_card_click',
    'sts_slot_failed',
    'sts_routine_picker_open', 'sts_routine_swap', 'sts_routine_see_all'
  ];

  /* The routine picker A/B test (assets/sts-ab.js) measures the site, not an
     audience: its events never reach an ad pixel, whatever the ad allow-list
     setting says, nor the Customer Events sandbox (custom pixels there can
     forward to one). GA4 (scrubbed) and our own telemetry only. */
  var NO_ADS = ['sts_routine_picker_open', 'sts_routine_swap', 'sts_routine_see_all'];

  /* Klaviyo gets three profile events and nothing else (09-Q30), and only for an
     identified customer. Never a concern list, which BLOCKED enforces anyway. */
  var KLAVIYO_EVENTS = ['sts_preference_saved', 'sts_reward_claimed', 'sts_library_topics_saved'];

  /* ───────────────────────────── small helpers ────────────────────────────── */

  function warn(msg, extra) { if (DEBUG && w.console) w.console.warn('[sts-track] ' + msg, extra || ''); }
  function log(name, params) { if (DEBUG && w.console) w.console.log('[sts-track] ' + name, params); }

  function uuid() {
    if (w.crypto && w.crypto.randomUUID) { try { return w.crypto.randomUUID(); } catch (e) { /* fall through */ } }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  /* Storage throws, not just fails, in Safari private browsing and with cookies
     blocked. Every access is wrapped; the failure mode is a session id that does
     not survive a page load, which costs a little dedupe and breaks nothing. */
  function ssGet(k) { try { return w.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { w.sessionStorage.setItem(k, v); return true; } catch (e) { return false; } }

  var memSession = null;
  function session() {
    if (memSession) return memSession;
    var raw = ssGet('stsSession');
    if (raw) { try { memSession = JSON.parse(raw); } catch (e) { memSession = null; } }
    if (!memSession || !memSession.id) memSession = { id: uuid(), seq: 0, stateSent: false };
    return memSession;
  }
  function saveSession() { ssSet('stsSession', JSON.stringify(memSession)); }
  function nextSeq() { var s = session(); s.seq = (s.seq || 0) + 1; saveSession(); return s.seq; }

  /* ───────────────────────────── session state ────────────────────────────── */

  /* Reads the object shape the merged resolver actually sets, and falls back to
     the flat shape spec §3.3 describes. See the header note. */
  function readState() {
    var S = w.STS || {};
    var st = S.state;
    if (st && typeof st === 'object') {
      return {
        name: st.name || 'qminus',
        type: st.type || null,
        loggedIn: !!st.loggedIn,
        source: st.source || 'device',
        lapsed: !!(st.flags && st.flags.lapsed),
        checkinDue: !!(st.flags && st.flags.checkinDue),
        quiz: st.quiz || null,
        typedAt: st.typedAt || null
      };
    }
    return {
      name: (typeof st === 'string' && st) || 'qminus',
      type: S.type || null,
      loggedIn: !!S.loggedIn,
      source: S.source || 'device',
      lapsed: !!S.lapsed,
      checkinDue: !!S.checkinDue,
      quiz: S.quizProgress || null,
      typedAt: null
    };
  }

  /* ───────────────────────────── the simulator gate ───────────────────────── */

  /* True when the state on the page came from the staff state simulator
     (snippets/sts-state-simulator.liquid) rather than from a real person.

     NOTHING SIMULATED LEAVES THIS SITE. Not GA4, not the first-party telemetry
     endpoint, not the Customer Events sandbox, not Meta, not Northbeam, not
     Klaviyo, not the GA4 user properties. One reviewer stepping through the six
     session rows and sixteen types is 96 fabricated sessions, each one shaped
     exactly like a customer's, and after they are in a report there is no field
     left that says which was which. A missing staff session costs nothing; a
     fabricated cohort costs every decision taken on that report.

     The check reads STS.state on every call rather than caching: Exit returns
     the page to the real state in the same tab, and events after it are real.

     PR #81 established this for the Klaviyo check-in property, which had its own
     `ci.source === 'preview'` test. That test is left where it is — it guards a
     path that does not go through send() — and the rule is now enforced at the
     transport as well, so a destination added later inherits it by default
     instead of having to remember. */
  function simulated() {
    try {
      var S = w.STS || {};
      var st = S.state;
      if (st && typeof st === 'object') {
        return st.source === 'preview' || !!(st.flags && st.flags.preview);
      }
      return S.source === 'preview';
    } catch (e) {
      return false;
    }
  }

  /* Quiz age is bucketed, never sent as a date. A date is close enough to an
     identifier when it is paired with a four-letter type. */
  function quizAgeBucket(typedAt) {
    if (!typedAt) return null;
    var ms = Date.now() - Date.parse(typedAt);
    if (!(ms >= 0)) return null;
    var days = ms / 86400000;
    if (days < 7) return '0-7';
    if (days < 30) return '8-30';
    if (days < 90) return '31-90';
    if (days < 182) return '91-182';
    if (days < 365) return '183-365';
    return '365+';
  }

  /* ───────────────────────────── cookie banner ────────────────────────────── */

  /* Not read, on purpose. Decision 2026-09-28 (Roger, via Luis): cookie
     behaviour stays exactly as on the live theme, where a No on Shopify's banner
     changes nothing. This file used to hold GA4, telemetry, Meta, Northbeam and
     Klaviyo back on Shopify.customerPrivacy; that was removed to match live.
     The simulator gate, the ad allow-list and the scrub below are not consent
     and all still apply. Do not put a consent check back without a new
     decision. */

  /* ───────────────────────────── the scrub ────────────────────────────────── */

  /* Returns a COPY. The caller's object is never mutated, so a scrubbed ad send
     can never quietly strip a field from the GA4 send that follows it. */
  function scrubForAds(params) {
    var out = {};
    if (!params) return out;
    var allowType = !!ads.skinType;
    var allowConcern = !!ads.concerns;
    for (var k in params) {
      if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
      if (BLOCKED.test(k)) { warn('ad payload: dropped blocked key "' + k + '"'); continue; }
      if (GATED_TYPE.test(k) && !allowType) { warn('ad payload: dropped gated key "' + k + '" (ads.skinType is off)'); continue; }
      if (GATED_CONCERN.test(k) && !allowConcern) { warn('ad payload: dropped gated key "' + k + '" (ads.concerns is off)'); continue; }
      out[k] = params[k];
    }
    return out;
  }

  function adEventAllowed(name) {
    var list = ads.events;
    if (!list || !list.length || NO_ADS.indexOf(name) > -1) return false;
    for (var i = 0; i < list.length; i++) if (list[i] === name) return true;
    return false;
  }

  /* ───────────────────────────── destinations ─────────────────────────────── */

  /* CALL THIS WITH scrubForAds(params), NEVER WITH THE RAW PAYLOAD. See the
     header: this store's Google tag is linked to Google Ads, so anything handed
     to gtag or pushed to the GTM container reaches a remarketing endpoint. */
  function toGA4(name, params) {
    if (typeof w.gtag === 'function') { w.gtag('event', name, params); return; }
    /* GTM container GTM-PFTT645 is on the page; a dataLayer push reaches it even
       before (or without) the gtag shim, so no event is lost to load order. */
    w.dataLayer = w.dataLayer || [];
    var push = { event: name };
    for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) push[k] = params[k];
    w.dataLayer.push(push);
  }

  function setUserProperties(props) {
    if (typeof w.gtag === 'function') { w.gtag('set', 'user_properties', props); return; }
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event: 'sts_user_properties', user_properties: props });
  }

  /* The first-party endpoint. Envelope copied verbatim from the quiz
     (assets/sts-liquid-quiz.js:220-267) so the backend needs no change. This is
     our own database: it is the one destination where the restricted fields are
     allowed to live, and nothing is scrubbed on the way in. */
  function toTelemetry(name, params, sid) {
    var base = cfg.ec2Base;
    if (!base) return;
    var body = JSON.stringify({
      events: [{
        event_uuid: uuid(),
        session_uuid: sid || session().id,
        client_seq: nextSeq(),
        occurred_at: new Date().toISOString(),
        event: name,
        widget_version: cfg.widgetVersion || 'v4-theme',
        page_context: cfg.pageType || null,
        device_class: params.device_class,
        detail: params
      }]
    });
    var url = base.replace(/\/+$/, '') + '/widget/events';
    try {
      if (w.navigator && typeof w.navigator.sendBeacon === 'function') {
        if (w.navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
      }
    } catch (e) { /* fall through to fetch */ }
    try {
      /* Deliberately NOT given a timeout, unlike every other fetch in the theme.
         This is the fallback for sendBeacon and it is keepalive, which exists so
         the request survives the page being closed — attaching an abort timer
         would kill exactly the events sent on unload, which are the ones a
         beacon is for. It has a catch, it paints nothing, and no UI waits on
         it, so a hang strands nobody. */
      w.fetch(url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: body })
        .catch(function () { /* fire and forget */ });
    } catch (e) { /* analytics must never break a page */ }
  }

  /* The Customer Events sandbox. No consent check here on purpose — the pixel
     sandbox applies the store's own consent rules to whatever it forwards, and
     it cannot forward anything we have not published. */
  function toShopifyPixel(name, params) {
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') {
        w.Shopify.analytics.publish('sts:' + name, params);
      }
    } catch (e) { /* never break a page */ }
  }

  function toMeta(name, params) {
    try {
      /* Only the loaded pixel, never the stub: fbevents.js loads twice on this
         store (Shopify's Facebook channel pixel and the GTM Meta tags) and both
         copies replay the stub queue, which was measured double-firing on
         2026-08-20. fbq.getState only exists once
         the real script has run. eventID makes a replay idempotent anyway. */
      if (typeof w.fbq !== 'function' || typeof w.fbq.getState !== 'function') return;
      w.fbq('trackCustom', name, params, { eventID: 'sts-' + uuid() });
    } catch (e) { /* never break a page */ }
  }

  function toNorthbeam(name) {
    try {
      if (w.Northbeam && typeof w.Northbeam.fireCustomGoal === 'function') {
        /* Name only. The live quiz already sends {} and there is no reason to
           start sending parameters to a destination that does not need them. */
        w.Northbeam.fireCustomGoal(name, {});
      }
    } catch (e) { /* never break a page */ }
  }

  /* Klaviyo never gets the skin type, whatever cfg.ads.skinType says: that
     setting is about ad pixels, and an email platform holding a four-letter
     type against a named profile is a different question nobody has answered. */
  function scrubForKlaviyo(params) {
    var out = scrubForAds(params);
    for (var k in out) if (Object.prototype.hasOwnProperty.call(out, k) && GATED_TYPE.test(k)) delete out[k];
    return out;
  }

  function toKlaviyo(name, params) {
    try {
      if (!cfg.customerId) return;
      if (KLAVIYO_EVENTS.indexOf(name) === -1) return;
      var k = w.klaviyo || w._learnq;
      if (!k) return;
      if (typeof k.push === 'function') { k.push(['track', name, params]); return; }
      if (typeof k.track === 'function') k.track(name, params);
    } catch (e) { /* never break a page */ }
  }

  /* G13b. One profile property, the date the six-month check-in falls due, so
     a Klaviyo flow can send the reminder. The date and nothing else: not the
     type, not the quiz date it was computed from, not the months count.

     Signed-in customers only (Klaviyo's own embed has identified them; this
     never sends an email address), never from the staff state simulator, and
     only when the value differs from the last one sent this session. STS.state.checkin is added by
     snippets/sts-server-facts.liquid on every sts:state, so a quiz finished or
     an account attached mid-session is picked up by the listener at boot. */
  function sendCheckinDue() {
    try {
      if (!cfg.customerId) return;
      var st = w.STS && w.STS.state;
      var ci = (st && typeof st === 'object') ? st.checkin : null;
      if (simulated()) return;
      if (!ci || !ci.dueAt || ci.source === 'preview') return;
      var s = session();
      if (s.klDue === ci.dueAt) return;
      var k = w.klaviyo || w._learnq;
      if (!k || typeof k.push !== 'function') return;
      k.push(['identify', { sts_checkin_due_at: ci.dueAt }]);
      s.klDue = ci.dueAt;
      saveSession();
      log('klaviyo identify', { sts_checkin_due_at: ci.dueAt });
    } catch (e) { /* never break a page */ }
  }

  /* G13c (2026-10-19). Tell Klaviyo's onsite script WHO a signed-out quiz
     taker is: the email they typed at the gate or the save offer, and nothing
     else (no type, no answers). Klaviyo already holds that profile (the quiz
     API adds every taker server-side), but its onsite events (Active on Site,
     Viewed Product, Added to Cart, which drive browse and cart abandonment)
     are only recorded for a browser it has identified. The Octane quiz did
     this; the Liquid quiz never has, and Active on Site fell from about 8,000
     a month (May) to 2,624 (Sep) as Octane was retired (Aug).
     Signed-in customers are skipped: Klaviyo's embed identifies them itself.
     Once per email per tab session, never from the staff simulator. */
  function hashStr(s) { var h = 5381; for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0; return String(h); }
  function identifyEmail(email) {
    try {
      if (cfg.customerId || simulated()) return false;
      email = String(email || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || /@temp\.quiz\.internal$/.test(email)) return false;
      var s = session(), h = hashStr(email);
      if (s.klId === h) return false;
      var k = w.klaviyo || w._learnq;
      if (!k || typeof k.push !== 'function') return false;
      k.push(['identify', { $email: email }]);
      s.klId = h;
      saveSession();
      log('klaviyo identify', { email: 'set' });
      return true;
    } catch (e) { return false; /* never break a page */ }
  }
  /* The quiz and the save offer keep the email in localStorage customerEmail
     (cleared on sign-out by assets/sts-logout.js), so a taker coming back on
     the same device is identified again on any page. */
  function identifyStoredEmail() {
    var e = null;
    try { e = w.localStorage.getItem('customerEmail'); } catch (x) { return; }
    if (e) identifyEmail(e);
  }

  /* ───────────────────────────── the one function ─────────────────────────── */

  function autoParams() {
    var s = readState();
    var p = {
      session_state: s.name,
      state_source: s.source,
      logged_in: s.loggedIn,
      page_type: cfg.pageType || null,
      template: cfg.template || null,
      device_class: (w.innerWidth && w.innerWidth <= 767) ? 'mobile' : 'desktop',
      checkin_due: s.checkinDue
    };
    if (s.type) p.skin_type = s.type;
    return p;
  }

  function send(name, params) {
    var merged = autoParams();
    if (params) {
      for (var k in params) {
        if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
        if (params[k] === undefined || params[k] === null || params[k] === '') continue;
        merged[k] = params[k];
      }
    }

    log(name, merged);

    /* There is no person here, so nothing leaves. Logged in debug mode so a
       reviewer can still see that the event fired and what it would have
       carried. */
    if (simulated()) {
      log('SUPPRESSED (simulated state) ' + name, merged);
      return;
    }

    /* scrubbed: gtag is linked to Google Ads AW-412659181 on this store. */
    toGA4(name, scrubForAds(merged));
    toTelemetry(name, merged);
    if (NO_ADS.indexOf(name) < 0) toShopifyPixel(name, merged);

    /* Everything below is an ad destination: the allow-list and the scrub. */
    if (adEventAllowed(name)) {
      var clean = scrubForAds(merged);
      toMeta(name, clean);
      toNorthbeam(name);
    }
    toKlaviyo(name, scrubForKlaviyo(merged));
  }

  /* The shopper leaving the page cancels its fetches, and every slot's catch
     then reported a "failure" ("Load failed" on iOS, "Failed to fetch" in
     Chrome) that was nothing but a tap on a link: most of the 9.6k
     sts_slot_failed in the first week of 2.0 (STS-CHECKOUT-LEAK-1019).
     Marked on the tap or submit that starts the navigation, because iOS
     Safari never fires beforeunload and pagehide comes after the fetch has
     already failed. Cleared on pageshow (back-forward cache) and after 10s
     (a link something else cancelled). */
  var leftAt = 0;
  function markLeaving(e) {
    if (e.defaultPrevented) return;
    if (e.type === 'click') {
      var a = e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ? null : e.target.closest && e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self') || /^(#|javascript:)/i.test(a.getAttribute('href'))) return;
    }
    leftAt = Date.now();
  }
  w.addEventListener('click', markLeaving);
  w.addEventListener('submit', markLeaving);
  w.addEventListener('pagehide', function () { leftAt = Date.now(); });
  w.addEventListener('pageshow', function () { leftAt = 0; });
  function leaving() { return !!leftAt && Date.now() - leftAt < 10000; }

  function stsTrack(name, params) {
    if (!name) return;
    if (name === 'sts_slot_failed' && leaving()) { log('SUPPRESSED (page is being left) ' + name, params); return; }
    if (DEBUG && EVENTS.indexOf(name) === -1) warn('unknown event name "' + name + '" — not in the §6.9 registry');
    try { send(name, params); } catch (e) { warn('send failed', e); }
  }

  /* ───────────────────────────── state resolved ───────────────────────────── */

  /* Once per session, in every state (§6.9 event 1). The two GA4 user-scoped
     properties are set here and nowhere else: sts_state and skin_type. The four
     the report proposed on top of those (logged_in, customer_tier, has_budget,
     topics_count) are event-scoped parameters instead, because they change
     inside a session and user properties are a limited resource. */
  function emitStateResolved() {
    var s = session();
    if (s.stateSent) return;
    /* setUserProperties writes sts_state and skin_type at USER scope, which
       outlives the event and would relabel the whole session. Return without
       marking stateSent, so the real state is still reported the moment the
       reviewer exits the preview or opens a page without one. */
    if (simulated()) return;
    var st = readState();

    var props = { sts_state: st.name };
    if (st.type) props.skin_type = st.type;
    setUserProperties(props);

    s.stateSent = true;
    saveSession();

    stsTrack('sts_state_resolved', {
      quiz_age_days: quizAgeBucket(st.typedAt),
      checkin_due: st.checkinDue,
      lapsed: st.lapsed,
      quiz_pct: st.quiz ? st.quiz.pct : null
    });
  }

  /* ───────────────────────────── quiz calls to action ─────────────────────── */

  /* §6.9 events 2, 5 and 6 are one tap seen three ways, so one function
     decides which it was and every page calls it: the header, the collection
     lock, the Skin Profile and the article cannot then disagree. `?retake` in
     the link wins; a visitor with answers saved is resuming; a typed visitor
     going back to the quiz is retaking it; everybody else is starting. A
     caller that knows better passes `kind` ('start' | 'resume' | 'retake').
     Without `kind`, a link that does not go to the quiz fires nothing and
     returns false, so a caller can hand it every link in a region. */
  var QUIZ_PATH = /\/pages\/skin-type-quiz\/?$/;

  function isQuizHref(href, quizUrl) {
    if (!href) return false;
    var path;
    try { path = new URL(href, w.location.href).pathname; } catch (e) { return false; }
    if (QUIZ_PATH.test(path)) return true;
    if (!quizUrl) return false;
    try { return path === new URL(quizUrl, w.location.href).pathname; } catch (e) { return false; }
  }

  function monthsSinceQuiz() {
    var st = w.STS && w.STS.state;
    var ci = (st && typeof st === 'object') ? st.checkin : null;
    if (ci && typeof ci.months === 'number') return ci.months;
    var s = readState();
    if (!s.typedAt) return null;
    var ms = Date.now() - Date.parse(s.typedAt);
    return ms >= 0 ? Math.round(ms / (30.44 * 86400000)) : null;
  }

  function quizClick(placement, href, kind, quizUrl) {
    if (!kind) {
      if (!isQuizHref(href, quizUrl)) return false;
      var s = readState();
      if (/[?&]retake\b/.test(href || '')) kind = 'retake';
      else if (s.name === 'qpartial') kind = 'resume';
      else if (s.type) kind = 'retake';
      else kind = 'start';
    }
    if (kind === 'retake') {
      stsTrack('sts_retake_quiz_click', { placement: placement, months_since_quiz: monthsSinceQuiz() });
    } else if (kind === 'resume') {
      var q = readState().quiz;
      stsTrack('sts_resume_quiz_click', { placement: placement, quiz_pct: q ? q.pct : null });
    } else {
      stsTrack('sts_quiz_cta_click', { placement: placement });
    }
    return true;
  }

  /* ───────────────────────────── first touch ──────────────────────────────── */

  /* Where this visitor first came from, for the quiz_start event only (the
     STS-Data Quiz Analytics traffic sources, replacing Octane's). Recorded on a
     landing — a page view with UTMs, a referrer from another site, or no
     referrer at all (typed, bookmark, app) — when nothing younger than 30 days
     is stored; later visits never overwrite it.
     Internal navigation records nothing, so a lost store reads "not captured",
     never "direct". Host only from the referrer, path only from the URL: no
     query string is kept. Never sent to an ad destination. */
  var FT_KEY = 'sts.ft', FT_MS = 30 * 86400000;
  function firstTouch() {
    try {
      var t = JSON.parse(w.localStorage.getItem(FT_KEY) || 'null');
      if (t && Date.now() - t.at < FT_MS) {
        var o = {};
        ['utm_source', 'utm_medium', 'utm_campaign', 'referrer_host', 'landing_path'].forEach(function (k) { if (t[k]) o[k] = t[k]; });
        return o;
      }
    } catch (e) { /* storage blocked */ }
    return null;
  }
  function recordFirstTouch() {
    try {
      if (firstTouch()) return;
      var q = new URLSearchParams(w.location.search), t = { at: Date.now(), landing_path: w.location.pathname.slice(0, 200) };
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { var v = q.get(k); if (v) t[k] = v.slice(0, 100); });
      var r = d.referrer ? new URL(d.referrer) : null, host = r && r.hostname.replace(/^www\./, '');
      if (host && host !== w.location.hostname.replace(/^www\./, '')) t.referrer_host = host;
      if (t.utm_source || t.utm_medium || t.utm_campaign || t.referrer_host || !r) w.localStorage.setItem(FT_KEY, JSON.stringify(t));
    } catch (e) { /* analytics must never break a page */ }
  }
  recordFirstTouch();

  /* ───────────────────────────── quiz → cart ──────────────────────────────── */

  /* The cart step of the STS-Data quiz funnel. The results page puts the quiz
     session on the cart (stq_session; STSRoutine.cart.stamp), and checkout and
     the order carry it from there. A cart write on any page while the cart
     holds that session and an item is one `quiz_cart` for that session, once
     per session per browser, to our own endpoint only. Nothing simulated. */
  var QC_KEY = 'sts.qc', QC_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function quizCart(e) {
    try {
      var c = e && e.detail && e.detail.cart, sid = c && c.attributes && c.attributes.stq_session;
      if (!sid || !QC_ID.test(sid) || !(c.item_count > 0) || simulated()) return;
      if (w.localStorage.getItem(QC_KEY) === sid) return;
      w.localStorage.setItem(QC_KEY, sid);
      toTelemetry('quiz_cart', { item_count: c.item_count }, sid);
    } catch (x) { /* storage blocked: send nothing rather than repeat */ }
  }
  d.addEventListener('sts:cart:updated', quizCart);
  d.addEventListener('theme:cart:change', quizCart);

  /* ───────────────────────────── boot ─────────────────────────────────────── */

  /* This file is deferred, so a section that fires on DOMContentLoaded can call
     stsTrack before it exists. snippets/sts-seo-analytics.liquid installs a
     four-line stub in <head> that pushes onto stsTrack.q; drain it here and
     nothing is lost to load order. */
  var pending = (w.stsTrack && w.stsTrack.q) || [];

  w.stsTrack = stsTrack;
  w.STSTrack = {
    track: stsTrack,
    events: EVENTS,
    /* Exposed for the QA gate (criteria 35-37): a reviewer can paste a payload
       into the console and see exactly what an ad destination would receive. */
    scrubForAds: scrubForAds,
    adEventAllowed: adEventAllowed,
    quizClick: quizClick,
    /* assets/sts-collection.js asks before its fallback location.assign(). */
    leaving: leaving,
    isQuizHref: isQuizHref,
    identifyEmail: identifyEmail,
    state: readState,
    /* assets/sts-liquid-quiz.js sends it with quiz_start. */
    firstTouch: firstTouch
  };

  for (var i = 0; i < pending.length; i++) stsTrack(pending[i][0], pending[i][1]);

  /* Not `{ once: true }` any more. emitStateResolved declines to fire while the
     state is simulated, so the listener has to survive long enough to fire when
     the reviewer exits the preview; `session().stateSent` is what stops it
     firing twice, and it always did. */
  if (w.STS && w.STS.state) emitStateResolved();
  d.addEventListener('sts:state', emitStateResolved);

  /* The Klaviyo embed loads on its own schedule, so the check-in date is tried
     now, again once the page has loaded, and on every later state change. */
  sendCheckinDue();
  w.addEventListener('load', sendCheckinDue, { once: true });
  d.addEventListener('sts:state', sendCheckinDue);
  identifyStoredEmail();
  w.addEventListener('load', identifyStoredEmail, { once: true });
}(window, document));
